import { CLIENT_PROJECT_TYPES_REFUSALS, ClientProjectTypesRefusal } from "@/data/models/ClientAdministrationRow";

/**
 * The Projekttypen card's logic (#2610081). Pure. IRES Cloud's `setClientProjectTypesForAdministration`
 * is the authority; these rules decide what the card and its dialog show and send.
 */

type Translate = (key: string, values?: unknown[]) => string;

/** A type as the card and the dialog name it: its default code and name, "LO Leckortung". */
export function projectTypeText(projectTypeId: number, t: Translate): string {
  return `${t(`projectDetails.projectTypeCodes.${projectTypeId}`)} ${t(`projectDetails.projectTypeDefaultLables.${projectTypeId}`)}`;
}

/** Two lists as sets, ascending without repeats. */
function normalised(ids: number[]): number[] {
  return Array.from(new Set(ids)).sort((left, right) => left - right);
}

/** Whether two lists of type ids differ, ignoring order. */
export function projectTypesDiffer(left: number[], right: number[]): boolean {
  const a = normalised(left);
  const b = normalised(right);
  return a.length !== b.length || a.some((id, index) => id !== b[index]);
}

/** The dialog may save when something changed and at least one type stays ticked. */
export function canSaveProjectTypes(stored: number[], form: number[]): boolean {
  return form.length > 0 && projectTypesDiffer(stored, form);
}

/** The types the form takes away, which IRES Cloud switches off in the client's table. */
export function withdrawnProjectTypes(stored: number[], form: number[]): number[] {
  return normalised(stored.filter((id) => !form.includes(id)));
}

/** IRES Cloud's refusal reason in a failed call, else null. */
export function clientProjectTypesRefusalOf(error: unknown): ClientProjectTypesRefusal | null {
  const reason = (error as { details?: { reason?: unknown } } | null)?.details?.reason;
  return typeof reason === "string" && CLIENT_PROJECT_TYPES_REFUSALS.includes(reason as ClientProjectTypesRefusal)
    ? (reason as ClientProjectTypesRefusal)
    : null;
}

/** The i18n key of a refusal from IRES Cloud, by its `details.reason`; a general failure otherwise. */
export function clientProjectTypesErrorKey(error: unknown): string {
  const reason = clientProjectTypesRefusalOf(error);
  return reason ? `admin.clients.projectTypes.errors.${reason}` : "admin.clients.projectTypes.errors.FAILED";
}
